import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { formatNumber, formatNumberDecimals } from 'utils/formats';

import { HistoryMovement } from 'types';

import movementTypes from 'modules/transactions/constants/movementTypes';

type SharesTransferTableRowProps = {
  movement: HistoryMovement;
  index: number;
};

const SharesTransferTableRow: FC<SharesTransferTableRowProps> = ({
  movement,
  index,
}) => {
  const { t } = useTranslate();

  const isTransferAllMovement =
    movement?.movementType === movementTypes.TRANSFER_ALL;

  return (
    <>
      <td
        className="tb-tnx-info text-left"
        key={`movement-partner-seller-${index}`}
      >
        <span className="title">{movement.partnerNameSeller}</span>
      </td>

      <td
        className="tb-tnx-info text-left"
        key={`movement-partner-buyer-${index}`}
      >
        <span className="title">{movement.partnerNameBuyer}</span>
      </td>

      <td className="tb-tnx-info text-left" key={`movement-class-${index}`}>
        <span className="title">{movement.holdingClassName}</span>
      </td>

      <td
        className="tb-tnx-info text-soft text-center"
        key={`movement-price-${index}`}
      >
        <span className="title">
          {formatNumberDecimals(movement.sharePrice)}
        </span>
      </td>

      {isTransferAllMovement ? (
        <td
          className="tb-tnx-info text-center"
          colSpan={2}
          key={`movement-type-${index}`}
        >
          <span className="title">{t('AllShares')}</span>
        </td>
      ) : (
        <>
          <td
            className="tb-tnx-info text-soft text-center"
            key={`movement-from-${index}`}
          >
            <span className="title">{formatNumber(movement.from)}</span>
          </td>
          <td
            className="tb-tnx-info text-soft text-center"
            key={`movement-to-${index}`}
          >
            <span className="title">
              <span className="title">{formatNumber(movement.to)}</span>
            </span>
          </td>
        </>
      )}
    </>
  );
};

export default SharesTransferTableRow;
